module.exports = __webpack_public_path__ + "img/hr-red-asterisk-01.2fe1e0ba.png";